// @ts-check

import React from "react";

import { BlockStack, Box, Text } from "@shopify/polaris";
import { LineChart } from "@shopify/polaris-viz";

import { useGlobalContext } from "context/GlobalContext";

import { SAMPLE_LINE_SALES_DATA } from "components/dashboard/util/sample-data";

const SampleLineChart = () => {
  const chartData = [
    {
      name: "Sample data",
      data: SAMPLE_LINE_SALES_DATA,
    },
  ];

  return (
    <LineChart
      theme="Light"
      data={chartData}
      showLegend={false}
      xAxisOptions={{ hide: true }}
    />
  );
};

const SyncingGraphic = ({ variant }) => {

  let background;
  if (variant) {
    let backgroundGraphic;
    if (variant === "line-chart") {
      backgroundGraphic = <SampleLineChart />;
    }

    background = (
      <div style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%", zIndex: "1", pointerEvents: "none", filter: "blur(2px)", paddingBlock: "var(--p-space-500)" }}>
        {backgroundGraphic}
      </div>
    );
  }

  return (
    <Box padding="0" position="relative">
      {background}

      <div style={{ zIndex: "2", position: "relative", backgroundColor: "rgba(255, 255, 255, 0.7)", width: "100%", height: "100%" }}>
        <Box paddingInline="800" paddingBlock="1000">
          <BlockStack gap="200" inlineAlign="center">
            <Text as="h2" variant="headingSm" tone="subdued">Syncing data</Text>

            <Text as="p" variant="bodyMd" alignment="center" tone="subdued">
              We're currently importing all of your past order data. If you have a lot of orders this could take up to 30 minutes.
            </Text>
          </BlockStack>
        </Box>
      </div>
    </Box>
  )
};

export const SyncingPlaceholder = ({ children, variant = null }) => {
  const { syncing } = useGlobalContext();

  if (syncing) {
    return <SyncingGraphic variant={variant} />;
  }

  return children;
};
